import React, { useEffect, useState } from "react";
import { SlClose } from "react-icons/sl";
import { TbSteeringWheel } from "react-icons/tb";



const BusCardComponent = (props) => {

    const [showSeats, setshowSeats] = useState(false);
    const handleCloseIcon = () => {

        setshowSeats(false)
    }

    return (
        <>
            <div className="ml-16 h-[20%] border-2 w-[85%] mt-7 rounded-lg shadow-lg mr-7">
                <div className="flex items-center justify-between pl-5 pr-8 pt-5 pb-5">
                    <div className="flex flex-col gap-2">
                        <p className="font-semibold text-lg">{props.busdata.departureTime}</p>
                        <p className="text-xs text-gray-400"></p>
                        <p className="font-semibold text-lg">{props.busdata.arrivalTime}</p>
                    </div>
                    <div className="flex flex-col gap-2 ">
                        <p className="text-lg font-semibold">{props.busdata.name}</p>
                        <p className="text-xs text-gray-400">{props.busdata.busType}</p>
                    </div>
                    <p className="text-xs text-gray-400"></p>
                    <p className="text-lg font-semibold"></p>
                    <button
                        onClick={() => setshowSeats(!showSeats)}
                        className="bg-[#FF6E1A] text-white px-3 py-1 rounded-md"
                    >
                        Select Seat
                    </button>
                </div>

                {showSeats ? (
                    <div className="bg-[#fff9c4] ">
                        <div className="flex gap-3 px-8 py-5 items-center justify-end">

                            <SlClose
                                className="h-6 w-6 cursor-pointer"
                                onClick={() => handleCloseIcon()}
                            />
                        </div>
                        <hr />
                        <div className="flex justify-between px-8 pt-5 pb-5 ">
                            <div className="bg-[#fff] p-2 px-4 flex flex-col rounded-lg">

                                <div className="text-center font-semibold">Lower Seats</div>
                                <TbSteeringWheel className="w-5 h-5 ml-auto mr-4" />
                                <div className="  flex gap-3 px-2 py-3 ">


                                    {props.busdata.lowerSeats.map((x) => (
                                        <div className="flex flex-col gap-4">
                                            {x.map((y) => (

                                                < div className={
                                                    "py-1 border   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 "} >
                                                    <p>{y.seatType}</p>
                                                    <p className="font-bold">{y.seatNumber}</p>
                                                    <p className="font-bold">{y.seatPrice}</p>
                                                </div>
                                            ))};

                                        </div>))}


                                </div>

                            </div>
                            <div className="bg-[#fff] p-2 px-4  flex flex-col rounded-lg ">
                                <div className="text-center font-semibold">Upper Seats</div>
                                <TbSteeringWheel className="w-5 h-5 ml-auto mr-4" />
                                <div className="  flex gap-3 px-2 py-3 ">


                                    {props.busdata.lowerSeats.map((x) => (
                                        <div className="flex flex-col gap-4">
                                            {x.map((y) => (

                                                < div className={
                                                    "py-1 border   border-gray-700  cursor-pointer text-xs w-[5rem] flex-col flex justify-center items-center gap-1 "} >
                                                    <p>{y.seatType}</p>
                                                    <p className="font-bold">{y.seatNumber}</p>
                                                    <p className="font-bold">{y.seatPrice}</p>
                                                </div>
                                            ))};

                                        </div>))}


                                </div>
                            </div>
                            <div className="bg-white p-3">
                                <p className="text-center font-bold">Boarding Points</p>
                                <div className="flex gap-5 items-center font-bold">
                                    <p>Time</p>
                                    <p className="text-center">Name</p>
                                </div>
                                {props.busdata.boardingPoint.map((x) => (
                                    <div className="flex gap-5 items-center pb-1">
                                        <p>{x.time}</p>
                                        <p>{x.pointname}</p>
                                    </div>

                                ))}
                                <p className="mt-3 text-center font-bold">Dropping Points</p>
                                <div className="flex gap-5 items-center font-bold">
                                    <p>Time</p>
                                    <p className="text-center">Name</p>
                                </div>
                                {props.busdata.droppingPoint.map((x) => (
                                    <div className="flex gap-5 items-center pb-1">
                                        <p>{x.time}</p>
                                        <p>{x.pointname}</p>
                                    </div>

                                ))}

                            </div>

                        </div>
                    </div>
                ) : (
                    <></>
                )}
            </div >
        </>
    );
};

export default BusCardComponent;
